import React from 'react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useAuth} from '../../../../../app/modules/auth/core/Auth'

const SidebarMenuExpense = () => {
  const intl = useIntl()
  const {can} = useAuth()

  const expenseViewPerms = [
    'accounting_expense_overview_view',
    'accounting_purchase_request_view',
    'accounting_purchase_order_view',
    'accounting_deposit_payment_view',
    'accounting_purchase_record_view',
    'accounting_expense_record_view',
    'accounting_purchase_tax_invoice_view',
    'accounting_receive_credit_note_view',
    'accounting_receive_debit_note_view',
    'accounting_payment_summary_view',
  ]

  return (
    <>
      {can(expenseViewPerms) && (
        <SidebarMenuItemWithSub to={'/expense'} title={'รายจ่าย'} icon='file-up'>
          {can('accounting_expense_overview_view') && (
            <SidebarMenuItem
              to='/expense-dashboard'
              icon='chart'
              title={'ภาพรวมรายจ่าย'}
              fontIcon='bi-app-indicator'
            />
          )}
        {/* <SidebarMenuItem
          to='/accounting/license-income'
          icon='document'
          title={'ใบแจ้งวิชาชีพ'}
          fontIcon='bi-app-indicator'
        /> */}
          {can('accounting_purchase_request_view') && (
            <SidebarMenuItem
              to='/expense-request-purchase-order'
              icon='document'
              title={'ใบขอสั่งซื้อ'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_purchase_order_view') && (
            <SidebarMenuItem
              to='/expense-purchase-order'
              icon='document'
              title={'ใบสั่งซื้อ'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_deposit_payment_view') && (
            <SidebarMenuItem
              to='/expense-deposit-payment'
              icon='document'
              title={'ใบจ่ายเงินมัดจำ'}
              fontIcon='bi-app-indicator'
            />
          )}
        {/* <SidebarMenuItem
          to='/expense-purchase-asset-order'
          icon='document'
          title={'ใบสั่งซื้อสินทรัพย์'}
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/expense-deposit-payment'
          icon='document'
          title={'ใบจ่ายเงินมัดจำ'}
          fontIcon='bi-app-indicator'
        /> */}
          {can('accounting_purchase_record_view') && (
            <SidebarMenuItem
              to='/expense-purchase-inventory-record'
              icon='document'
              title={'บันทึกซื้อสินค้า'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_expense_record_view') && (
            <SidebarMenuItem
              to='/expense-expense-record'
              icon='document'
              title={'บันทึกค่าใช้จ่าย'}
              fontIcon='bi-app-indicator'
            />
          )}
        {/* <SidebarMenuItem
          to='/expense-purchase-asset-order'
          icon='document'
          title={'ใบสั่งซื้อสินทรัพย์'}
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/expense-purchase-asset'
          icon='document'
          title={'ซื้อสินทรัพย์'}
          fontIcon='bi-app-indicator'
        /> */}
          {can('accounting_purchase_tax_invoice_view') && (
            <SidebarMenuItem
              to='/expense-purchase-tax-invoice'
              icon='document'
              title={'ใบกำกับภาษีซื้อ'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_receive_credit_note_view') && (
            <SidebarMenuItem
              to='/expense-purchase-credit-note'
              icon='document'
              title={'รับใบลดหนี้'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_receive_debit_note_view') && (
            <SidebarMenuItem
              to='/expense-purchase-debit-note'
              icon='document'
              title={'รับใบเพิ่มหนี้'}
              fontIcon='bi-app-indicator'
            />
          )}
          {can('accounting_payment_summary_view') && (
            <SidebarMenuItem
              to='/expense-combined-payment-note'
              icon='document'
              title={'ใบรวมจ่าย'}
              fontIcon='bi-app-indicator'
            />
          )}
        </SidebarMenuItemWithSub>
      )}
    </>
  )
}

export default SidebarMenuExpense
